import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ParentalUtilsService } from 'src/app/services/parental-utils.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-account-selection-modal',
  templateUrl: './account-selection-modal.component.html',
  styleUrls: ['./account-selection-modal.component.scss']
})
export class AccountSelectionModalComponent implements OnInit {

  @Input('data') data: any;
  userAccounts: any[]  = [];
  selectedSku: any;
  constructor(
    private modalController: ModalController, 
    private SKUDS: SkuDataService,
    private SS: SubjectService,
    private router: Router,
    private UTS: UtilitiesService,
    private PU: ParentalUtilsService) { }

  ngOnInit(): void {
    this.userAccounts = this.data;
  }

  verifySelectedAccount(account: any){
    this.userAccounts.forEach(acc => {acc['selected'] = false;})
    account['selected'] = true;
    this.selectedSku = this.PU.getRelatedAddon(account?.accountType);
    this.SKUDS.set(this.selectedSku);
    this.SS.skuDetails.next(this.selectedSku);
    this.PU.setSelectedAccount(account);
  }
  continueToConfigScreen(){
    this.modalController.dismiss();
    const redirectionUrl = this.PU.navigateAddonDetailUrl(this.selectedSku);
    this.router.navigateByUrl(redirectionUrl);
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }


}
